import { toast } from "@/components/toast/toast-queue";
import { deleteAttachment } from "@/lib/api/attachments";

/** Deletes an MBC file, then lets the caller refetch the brief. */
export function useDeleteAsset(
  onDeleted: () => void,
): (attachmentId: number) => Promise<void> {
  return (attachmentId: number) =>
    deleteAttachment(attachmentId)
      .then(onDeleted)
      .catch(() => {
        toast.add({
          description: "Please try again.",
          title: "Couldn't delete that file",
          type: "error",
        });
      });
}
